export class UnitTypeModel {
  public static readonly TYPE_ID_USER_SELECTABLE = 1;
  public static readonly TYPE_ID_REQUIRE_ENABLED = 2;
  public static readonly TYPE_ID_REQUIRE_DISABLED = 3;
  public id: number;
  public name: string;
  public description: string;
  public monitoring_module_config_type_id: number;
}

